export const SET_TOAST_ERROR = 'SET_TOAST_ERROR';
export const SET_TOAST_SUCCESS = 'SET_TOAST_SUCCESS';
